import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Globe } from "lucide-react";
import LeadCaptureManager from "./LeadCaptureManager";

export default function LeadCaptureDrawer({ onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => setVisible(true));
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const close = () => {
    setVisible(false);
    setTimeout(onClose, 250);
  };

  const header = (
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
      <div className="flex items-center gap-2">
        <Globe size={18} className="text-emerald-600" />
        <span className="text-base font-semibold text-gray-900">
          Buzón web de leads
        </span>
      </div>
      <button
        onClick={close}
        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <X size={18} className="text-gray-400" />
      </button>
    </div>
  );

  const panel = (
    <div className="fixed inset-0 z-[99999]">
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-250 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
        onClick={close}
      />

      {/* Desktop: drawer derecho */}
      <div
        className={`
          hidden md:flex fixed top-0 right-0 h-full w-full max-w-xl
          flex-col bg-white shadow-2xl
          transition-transform duration-250 ease-out
          ${visible ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {header}
        <div className="flex-1 px-6 py-6 overflow-y-auto">
          <LeadCaptureManager />
        </div>
      </div>

      {/* Mobile: sheet desde abajo (full-screen) */}
      <div
        className={`
          md:hidden fixed inset-0 bg-white
          transition-transform duration-250 ease-out
          ${visible ? "translate-y-0" : "translate-y-full"}
          flex flex-col
        `}
      >
        {header}
        <div className="flex-1 px-5 py-4 overflow-y-auto">
          <LeadCaptureManager />
        </div>
      </div>
    </div>
  );

  return createPortal(panel, document.body);
}
